<template>
<div class="layout">
  <div class="layout__header">
    <h3>Preferencias</h3>
  </div>
  <div class="row">
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="password" v-model="form.password_firma_digital" id="contrasena_firma_electronica" placeholder="Ingrese la contraseña...">
          <span>Contraseña de firma electrónica</span>
          <span v-if="errores.password_firma_digital" class="helper-text text-danger" slot="helper">
            {{ errores.password_firma_digital[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="password" v-model="form.password_firma_digital_confirmation" id="contrasena_firma_electronica_confirmation" placeholder="Confirme la contraseña...">
          <span>Confirme la contraseña de la firma electrónica</span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.nombre_firma_electronica" id="nombre_firma_electronica" placeholder="Nombre en el archivo de la firma">
          <span>Nombre de archivo de firma electrónica</span>
          <span v-if="errores.nombre_firma_electronica" class="helper-text text-danger" slot="helper">
            {{ errores.nombre_firma_electronica[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field select2">
        <div class="select2-field">
          <v-select label="descripcion" placeholder="Seleccione..." id="tipoAmbiente" v-model="selectedTipoAmbiente" :options="tiposAmbiente"></v-select>
          <label for="tipoAmbiente">Tipo de ambiente</label>
          <span v-if="errores.id_tipo_ambiente" class="helper-text text-danger" slot="helper">
            {{ errores.id_tipo_ambiente[0] }}
          </span>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.smtp_user" id="smtp_user" placeholder="Usuario SMTP">
          <span>Dirección electrónica SMTP (Usuario)</span>
          <span v-if="errores.smtp_user" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_user[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="password" v-model="form.smtp_password" id="smtp_password" placeholder="Contraseña SMTP">
          <span>Contraseña SMTP (Usuario)</span>
        </input-field>
        <span v-if="errores.smtp_password" class="helper-text text-danger" slot="helper">
          {{ errores.smtp_password[0] }}
        </span>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="password" v-model="form.smtp_password_confirmation" id="smtp_password_confirmation"
          placeholder="Confirmación SMTP">
          <span>Confirmar contraseña SMTP (Usuario)</span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.motivo_correo" id="motivo_correo" placeholder="Escriba el motivo...">
          <span>Motivo de correo (Facturación)</span>
          <span v-if="errores.motivo_correo" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.motivo_correo[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.smtp_host" id="servidor_smtp" placeholder="Host SMTP">
          <span>Servidor SMTP de correos</span>
          <span v-if="errores.smtp_host" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.smtp_host[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field vMoney :format="int" type="number" v-model="form.smtp_port" id="puerto_servidor" placeholder="Puerto SMTP">
          <span>Puerto en el servidor</span>
          <span v-if="errores.smtp_port" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.smtp_port[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <label for="servidor_smtp_usa_ssl">
          <input type="checkbox" v-model="form.smtp_seguridad" id="servidor_smtp_usa_ssl">
          <span>El servidor de correo SMTP usa SSL</span>
        </label>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <label for="permitir_facturacion">
          <input type="checkbox" v-model="form.permitir_facturacion" id="permitir_facturacion">
          <span>Permitir facturación</span>
        </label>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field select">
        <div class="select-field">
          <select name="tipo_facturacion" id="tipo_facturacion" v-model="form.tipo_facturacion">
            <option value="OF">Offline</option>
            <option value="ON">Online</option>
          </select>
          <label for="tipo_facturacion">Tipo de facturación</label>
        </div>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field vMoney :format="int" type="number" v-model="form.minutos_firma" id="minutos_firma" placeholder="(En minutos)">
          <span>Intervalo de firma de documentos</span>
          <span v-if="errores.minutos_firma" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.minutos_firma[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field vMoney :format="int" type="number" v-model="form.minutos_autorizacion" id="minutos_autorizacion" placeholder="(En minutos)">
          <span>Intervalo de autorización de documentos</span>
          <span v-if="errores.minutos_autorizacion" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.minutos_autorizacion[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field vMoney :format="int" type="number" v-model="form.minutos_email" id="minutos_email" placeholder="(En minutos)">
          <span>Intervalo de envío de correos</span>
          <span v-if="errores.minutos_email" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.minutos_email[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.path_correo" id="servidor_smtp" placeholder="Nombre de fichero">
          <span>Plantilla de correo (HTML)</span>
          <span v-if="errores.path_correo" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.path_correo[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.path_factura" id="plantilla_factura" placeholder="Nombre de fichero">
          <span>Plantilla de factura (HTML)</span>
          <span v-if="errores.path_factura" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.path_factura[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.path_nota_credito" id="plantilla_nc" placeholder="Nombre de fichero">
          <span>Plantilla de nota de crédito (HTML)</span>
          <span v-if="errores.path_nota_credito" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.path_nota_credito[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.path_retencion" id="plantilla_retencion" placeholder="Nombre de fichero">
          <span>Plantilla de retención (HTML)</span>
          <span v-if="errores.path_retencion" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.path_retencion[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.path_guia_remision" id="plantilla_gr" placeholder="Nombre de fichero">
          <span>Plantilla de guía de remisión (HTML)</span>
          <span v-if="errores.path_guia_remision" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.path_guia_remision[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.precision" id="servidor_smtp" placeholder="##.##">
          <span>Precisión de decimales</span>
          <span v-if="errores.precision" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.precision[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field v-mask="'###'" type="tel" v-model="form.dias_alerta" id="servidor_smtp" placeholder="###">
          <span>Días de alerta de pago</span>
          <span v-if="errores.dias_alerta" class="helper-text text-danger" slot="helper">
            <strong>{{ errores.dias_alerta[0] }}</strong>
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.imap_user" id="imap_user" placeholder="Usuario IMAP">
          <span>Dirección electrónica IMAP (Usuario)</span>
          <span v-if="errores.imap_user" class="helper-text text-danger" slot="helper">
            {{ errores.imap_user[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="password" v-model="form.imap_password" id="imap_password" placeholder="Contraseña IMAP">
          <span>Contraseña de usuario IMAP</span>
          <span v-if="errores.imap_password" class="helper-text text-danger" slot="helper">
            {{ errores.imap_password[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="password" v-model="form.imap_password_confirmation" id="imap_password_confirmation" placeholder="Confirmar contraseña IMAP">
          <span>Confirmación de contraseña de usuario IMAP</span>
          <span v-if="errores.imap_password_confirmation" class="helper-text text-danger" slot="helper">
            {{ errores.imap_password_confirmation[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.imap_host" id="imap_host" placeholder="Host IMAP">
          <span>Servidor IMAP</span>
          <span v-if="errores.imap_host" class="helper-text text-danger" slot="helper">
            {{ errores.imap_host[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field v-mask="'######'" type="tel" v-model="form.imap_port" id="imap_port" placeholder="Puerto IMAP">
          <span>Puerto IMAP</span>
          <span v-if="errores.imap_port" class="helper-text text-danger" slot="helper">
            {{ errores.imap_port[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <p>
        <label for="imap_tls">
          <input type="checkbox" name="imap_tls" id="imap_tls" v-model="form.imap_tls"><span>SSL/TLS Imap</span>
        </label>
      </p>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.c_smtp_host" id="c_smtp_host" placeholder="Host SMTP">
          <span>Servidor SMTP</span>
          <span v-if="errores.c_smtp_host" class="helper-text text-danger" slot="helper">
            {{ errores.c_smtp_host[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field v-mask="'######'" type="tel" v-model="form.c_smtp_port" id="c_smtp_port" placeholder="Puerto SMTP">
          <span>Puerto SMTP</span>
          <span v-if="errores.c_smtp_port" class="helper-text text-danger" slot="helper">
            {{ errores.c_smtp_port[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <p>
        <label for="c_smtp_tls">
          <input type="checkbox" name="c_smtp_tls" id="c_smtp_tls" v-model="form.c_smtp_tls"><span>SSL/TLS SMTP</span>
        </label>
      </p>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.smtp_alertas_host" id="smtp_alertas_host" placeholder="Host SMTP">
          <span>Servidor SMTP (Alertas de saldos)</span>
          <span v-if="errores.smtp_alertas_host" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_alertas_host[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field v-mask="'######'" type="tel" v-model="form.smtp_alertas_port" id="smtp_alertas_port" placeholder="Puerto SMTP">
          <span>Puerto SMTP (Alertas de saldos)</span>
          <span v-if="errores.smtp_alertas_port" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_alertas_port[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <p>
        <label for="smtp_alertas_tls">
          <input type="checkbox" name="smtp_alertas_tls" id="smtp_alertas_tls" v-model="form.smtp_alertas_tls"><span>SSL/TLS SMTP (Alertas de saldos)</span>
        </label>
      </p>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.smtp_alertas_usuario" id="smtp_alertas_usuario" placeholder="Usuario SMTP">
          <span>Usuario SMTP (Alertas de saldos)</span>
          <span v-if="errores.smtp_alertas_usuario" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_alertas_usuario[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="password" v-model="form.smtp_alertas_password" id="smtp_alertas_password" placeholder="Contraseña SMTP">
          <span>Contraseña SMTP (Alertas de saldos)</span>
          <span v-if="errores.smtp_alertas_password" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_alertas_password[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field v-mask="'######'" type="tel" v-model="form.smtp_alertas_dias_antelacion" id="smtp_alertas_dias_antelacion" placeholder="# Días">
          <span>Días de antelación</span>
          <span v-if="errores.smtp_alertas_dias_antelacion" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_alertas_dias_antelacion[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="email" v-model="form.smtp_alertas_correo_emisor" id="smtp_alertas_correo_emisor" placeholder="Escriba el correo de emisión...">
          <span>Correo de emisor SMTP (Alertas de saldos)</span>
          <span v-if="errores.smtp_alertas_correo_emisor" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_alertas_correo_emisor[0] }}
          </span>
        </input-field>
      </div>
    </div>
    <div class="col-xs-12 col-md-4">
      <div class="form-field">
        <input-field type="text" v-model="form.smtp_alertas_nombre_emisor" id="smtp_alertas_nombre_emisor" placeholder="Escriba el nombre del emisor...">
          <span>Nombre de emisor SMTP (Alertas de saldos)</span>
          <span v-if="errores.smtp_alertas_nombre_emisor" class="helper-text text-danger" slot="helper">
            {{ errores.smtp_alertas_nombre_emisor[0] }}
          </span>
        </input-field>
      </div>
    </div>
  </div>
  <div class="modal-buttons">
    <button @click="$emit('cerrar')" class="btn-danger btn--text" type="button"><i class="fa fa-sign-out"></i> <span>Cerrar</span></button>
    <button @click="guardarCambios" class="btn-success" type="button"><i class="fa fa-save"></i> <span>Guardar</span></button>
  </div>
</div>
</template>

<script>
export default {
    data : function () {
        return {
            form : {
              c_smtp_host : '',
              c_smtp_port : '',
              c_smtp_tls : false,
              imap_tls : false,
              imap_user : '',
              imap_password : '',
              imap_password_confirmation : '',
              imap_host : '',
              imap_port : '',
              password_firma_digital : '',
              password_firma_digital_confirmation : '',
              id_tipo_ambiente : '',
              permitir_facturacion : true,
              smtp_user : '',
              smtp_password : '',
              smtp_password_confirmation : '',
              smtp_port : '',
              smtp_host : '', 
              smtp_seguridad : '',
              minutos_firma : 0,
              minutos_email : 0,
              minutos_autorizacion : 0,
              motivo_correo : '',
              nombre_firma_electronica : '',
              path_correo : '',
              path_factura : '',
              path_nota_credito : '',
              path_retencion : '',
              path_guia_remision : '',
              precision : '',
              dias_alerta : 5,
              smtp_alertas_host: '',
              smtp_alertas_port: '',
              smtp_alertas_tls: false,
              smtp_alertas_usuario: '',
              smtp_alertas_password: '',
              smtp_alertas_dias_antelacion: '',
              smtp_alertas_correo_emisor: '',
              smtp_alertas_nombre_emisor: '',
              tipo_facturacion: 'OF'
            },
            errores : {
                password_firma_digital : undefined,
                password_firma_digital_confirmation : undefined,
                id_tipo_ambiente : undefined,
                permitir_facturacion : undefined,
                smtp_user : undefined,
                smtp_password : undefined,
                smtp_password_confirmation : undefined,
                smtp_port : undefined,
                smtp_host : undefined, 
                smtp_seguridad : undefined,
                minutos_firma : undefined,
                minutos_email : undefined,
                minutos_autorizacion : undefined,
                motivo_correo : undefined,
                nombre_firma_electronica : undefined,
                path_correo : undefined,
                path_factura : undefined,
                path_nota_credito : undefined,
                path_retencion : undefined,
                precision : undefined,
                path_guia_remision : undefined,
                dias_alerta : undefined,
                smtp_alertas_host: undefined,
                smtp_alertas_port: undefined,
                smtp_alertas_tls: undefined,
                smtp_alertas_usuario: undefined,
                smtp_alertas_password: undefined,
                smtp_alertas_dias_antelacion: undefined,
                smtp_alertas_correo_emisor: undefined,
                smtp_alertas_nombre_emisor: undefined,
            },
            url : url,
            tiposAmbiente : [],
            selectedTipoAmbiente : null,
            int : int
        }
    },
    methods : {
        limpiarErrores : function(){
            this.errores = {
              smtp_alertas_host: undefined,
              smtp_alertas_port: undefined,
              smtp_alertas_tls: undefined,
              smtp_alertas_usuario: undefined,
              smtp_alertas_password: undefined,
              smtp_alertas_dias_antelacion: undefined,
              smtp_alertas_correo_emisor: undefined,
              smtp_alertas_nombre_emisor: undefined,
                password_firma_digital : undefined,
                password_firma_digital_confirmation : undefined,
                id_tipo_ambiente : undefined,
                permitir_facturacion : undefined,
                smtp_user : undefined,
                smtp_password : undefined,
                smtp_password_confirmation : undefined,
                smtp_port : undefined,
                smtp_host : undefined, 
                smtp_seguridad : undefined,
                minutos_firma : undefined,
                minutos_email : undefined,
                minutos_autorizacion : undefined,
                motivo_correo : undefined,
                nombre_firma_electronica : undefined,
                path_correo : undefined,
                path_factura : undefined,
                path_nota_credito : undefined,
                path_retencion : undefined,
                precision : undefined,
                dias_alerta : undefined
            };
        },
        guardarCambios : function(){
            let that = this;
            this.limpiarErrores();
            let precision = parseFloat(this.form.precision);
            if (!isNaN(precision) && (precision > 6 || precision < 2)) {
              swal('La precisión máxima es de 6 y la mínima es de 2.', 'Mensaje', 'warning');
              return;
            }
            axios.post(this.url + '/parametros/preferencias', that.form).then(function(response) {    
                swal({
                    type: 'success',
                    title: 'Realizado',
                    text: 'Los parámetros de preferencias han sido actualizados.'
                });       
            }).catch(function(error) {            
                let response = error.response;
                if (response !== null) {
                    let status = response.status;
                    if (status === 422) {
                        that.errores = response.data.errors;
                    }
                }
            });
        },
        cargarDatos : function () {
            let that = this;
            axios.get(this.url + '/parametros/preferencias/datos').then(function (response) {
                that.tiposAmbiente = response.data.tiposAmbiente;
                if (response.data.configuracionEmpresa !== null) {
                    let configuracionEmpresa = response.data.configuracionEmpresa;
                    that.form.tipo_facturacion = configuracionEmpresa.tipo_facturacion;
                    that.form.c_smtp_host = configuracionEmpresa.c_smtp_host;
                    that.form.c_smtp_port = configuracionEmpresa.c_smtp_port;
                    that.form.c_smtp_tls = configuracionEmpresa.c_smtp_tls === 'S';
                    that.form.imap_tls = configuracionEmpresa.imap_tls === 'S';
                    that.form.imap_user = configuracionEmpresa.imap_user;
                    that.form.imap_host = configuracionEmpresa.imap_host;
                    that.form.imap_port = configuracionEmpresa.imap_port;
                    that.form.minutos_firma = configuracionEmpresa.minutos_firma;
                    that.form.minutos_email = configuracionEmpresa.minutos_email;
                    that.form.minutos_autorizacion = configuracionEmpresa.minutos_autorizacion;
                    that.form.motivo_correo = configuracionEmpresa.motivo_correo;
                    that.form.permitir_facturacion = configuracionEmpresa.permitir_facturacion === 'S';
                    that.form.smtp_user = configuracionEmpresa.smtp_user;
                    that.form.smtp_port = configuracionEmpresa.smtp_port;
                    that.form.smtp_host = configuracionEmpresa.smtp_host;
                    that.form.smtp_seguridad = configuracionEmpresa.smtp_seguridad === 'S';
                    that.form.id_tipo_ambiente = configuracionEmpresa.id_tipo_ambiente;
                    that.form.path_correo = configuracionEmpresa.path_html_correo;
                    that.form.path_factura = configuracionEmpresa.path_factura_ride;
                    that.form.path_nota_credito = configuracionEmpresa.path_nc_ride;
                    that.form.precision = configuracionEmpresa.precision;
                    that.form.path_retencion = configuracionEmpresa.path_ret_ride;
                    that.form.path_guia_remision = configuracionEmpresa.path_guia_remision;
                    that.form.nombre_firma_electronica = configuracionEmpresa.path_firma_digital;
                    that.form.dias_alerta = configuracionEmpresa.dias_alerta;
                    that.form.smtp_alertas_host = configuracionEmpresa.smtp_alertas_host;
                    that.form.smtp_alertas_port = configuracionEmpresa.smtp_alertas_port;
                    that.form.smtp_alertas_tls = configuracionEmpresa.smtp_alertas_tls === 'S';
                    that.form.smtp_alertas_usuario = configuracionEmpresa.smtp_alertas_usuario;
                    that.form.smtp_alertas_password = configuracionEmpresa.smtp_alertas_password;
                    that.form.smtp_alertas_dias_antelacion = configuracionEmpresa.smtp_alertas_dias_antelacion;
                    that.form.smtp_alertas_correo_emisor = configuracionEmpresa.smtp_alertas_correo_emisor;
                    that.form.smtp_alertas_nombre_emisor = configuracionEmpresa.smtp_alertas_nombre_emisor;
                    for (let i = 0; i < that.tiposAmbiente.length; i++)
                        if (that.tiposAmbiente[i].id_tipo_ambiente === that.form.id_tipo_ambiente) {
                            that.selectedTipoAmbiente = that.tiposAmbiente[i];
                            break;
                        }
                }
            });
        }
    },
    mounted : function(){
        this.cargarDatos();
    },
    watch : {
        selectedTipoAmbiente : function (value) {
            if (value !== undefined && value !== null)
                this.form.id_tipo_ambiente = value.id_tipo_ambiente;
            else 
                this.form.id_tipo_ambiente = '';
        }
    }

}
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/forms/mantenimiento/parametrizacion/ParametrosPreferencias.vue